if (!window.awFooterLoaded) {
  window.awFooterLoaded = true;

  const syncAwFooter = (footer) => {
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    footer.querySelectorAll('[data-aw-footer-details]').forEach((details) => {
      if (mobile) details.removeAttribute('open');
      else details.setAttribute('open', '');
    });
  };

  const initAwFooters = (root = document) => {
    root.querySelectorAll('[data-aw-footer]').forEach((footer) => {
      if (footer.dataset.awFooterReady) return;
      footer.dataset.awFooterReady = 'true';
      syncAwFooter(footer);
      const media = window.matchMedia('(max-width: 749px)');
      const onChange = () => syncAwFooter(footer);
      media.addEventListener('change', onChange);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAwFooters());
  } else {
    initAwFooters();
  }
  document.addEventListener('shopify:section:load', (event) => initAwFooters(event.target));
}
